/**
 * @file   src\mobile\components\Common\UserPlan\MonthlyAgentPlan.js
 * @brief  This file is responsible for monthly plan selction view for agent user in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Button from "react-bootstrap/Button";
import { getUserType } from "../../../../helpers/common";
import { USER_TYPE_MEMBER } from "../../../../constants/common";

const MonthlyMemberPlan = (props) => {
  const {
    userDetails,
    handleUpgrade,
    upgradeUserToFreePlan,
    handleDowngrade,
    ContactModalShow,
  } = props;
  return (
    <>
      <div className="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 className="d-flex align-items-center plan-color-blue">
          Pro Member <span className="pro-blue-badge">PRO</span>
        </h4>
        <p className="pb-20 plan-color-blue">
          Specific features for agents and teams to create and manage deals.
        </p>
        <p className="short-para-blue">
          $15/month<span>Billed monthly</span>
        </p>

        <div className="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-primar"
              onClick={() => handleUpgrade(2, "Pro Member")}
            >
              Select
            </Button>
          ) : (
            <Button
              variant="primary"
              className="plan-btn btn btn-primar"
              disabled={
                userDetails?.PlanName === "Pro Member" &&
                userDetails?.period === 2
              }
              onClick={() => handleUpgrade(2, "Pro Member")}
            >
              {userDetails?.PlanName === "Pro Member" &&
              userDetails?.period === 2
                ? "Your Current Plan"
                : "Upgrade"}
            </Button>
          )}
        </div>
        <ul className="plan-features-list plan-color-blue">
          <li className="plan-features-listbg-blue">
            Client management dashboard
          </li>
          <li className="plan-features-listbg-blue">Unlimited want-listings</li>
          <li className="plan-features-listbg-blue">
            Unlimited properties in your inventory
          </li>
          <li className="plan-features-listbg-blue">
            10 free introductions per month
          </li>
          <li className="plan-features-listbg-blue">
            Custom agent profile and Pro badge
          </li>
          <li className="plan-features-listbg-blue">
            Branded Buyer Digital Listing Form
          </li>
          <li className="plan-features-listbg-blue">
            See other Pro Member's contact info
          </li>
        </ul>
      </div>

      <div className="mob-plan-wraper w-100 plan-bg-white plan-brdr-grey mb-20">
        <h4 className="d-flex align-items-center plan-color-black">Lite</h4>
        <p className="pb-20">
          Get a taste of what Gitcha can do with limited features.
        </p>
        <p className="short-para-black">Free</p>

        <div className="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ||
          getUserType() === USER_TYPE_MEMBER ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-primar"
              onClick={() => upgradeUserToFreePlan()}
            >
              Select
            </Button>
          ) : userDetails?.PlanName === "Lite" ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-secondary-blue"
              disabled
            >
              Your Current plan
            </Button>
          ) : (
            <Button
              variant="outline"
              className="btn-outline-primary plan-btn downgrade-btn"
              onClick={handleDowngrade}
            >
              Downgrade
            </Button>
          )}
        </div>
        <ul className="plan-features-list plan-features-listtext-black">
          <li className="plan-features-listbg-black">Pay per introduction</li>
          <li className="plan-features-listbg-black">
            Up to 2 properties in your inventory
          </li>
          <li className="plan-features-listbg-black">Unlimited want-listings</li>
        </ul>
      </div>
      <div className="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 className="d-flex align-items-center plan-color-blue">Enterprise</h4>
        <p className="pb-20 plan-color-blue">
          Empowering your agency’s full team with Premium benefits
        </p>
        <p className="short-para-blue">Tiered pricing/seat</p>
        <div className="btn-sec btn-sec-btmbrder-blue">
          <button
            type="button"
            className="plan-btn btn btn-primary"
            onClick={() => {
              ContactModalShow();
            }}
          >
            Contact us
          </button>
        </div>
        <ul className="plan-features-list plan-color-blue">
          <li className="plan-features-listbg-blue">
            Custom agent profile and Premium badge
          </li>
          <li className="plan-features-listbg-blue">
            Unlimited properties in your inventory
          </li>
          <li className="plan-features-listbg-blue">
            Free introductions per month
          </li>
          <li className="plan-features-listbg-blue">
            Client management dashboard
          </li>
          <li className="plan-features-listbg-blue">
            Exclusive market analytics, real-time buyer demand and private
            inventory data reports
          </li>
          <li className="plan-features-listbg-blue">Unlimited want-listings</li>
        </ul>
      </div>
      <div className="mob-plan-wraper w-100 plan-bg-darkblue mb-20 p-0 border-0">
        <h4 className="d-flex align-items-center plan-color-white pt-20 pe-4 ps-4">
          Pro Preferred <span className="pro-gold-badge">PRO</span>
        </h4>
        <p className="pb-20 plan-color-mildblue pe-4 ps-4">
          This plan is currently not available but will be coming soon.
        </p>
        <p className="short-para-white pe-4 ps-4">
          Get notified when available for upgrade
        </p>
        <div className="btn-sec btn-sec-btmbrder-blue pe-4 ps-4 mb-0">
          <button type="button" className="plan-btn btn btn-yellow-gradient">
            Notify me
          </button>
        </div>
        <ul className="plan-features-list plan-color-white plan-feature-blur pe-4 ps-4 pt-20 pb-20">
          <li className="plan-features-listbg-white">Pay per introduction</li>
          <li className="plan-features-listbg-white">
            Up to 2 properties in your inventory
          </li>
          <li className="plan-features-listbg-white">Unlimited want-listings</li>
        </ul>
      </div>
    </>
  );
};

export default MonthlyMemberPlan;
